export var EndpointURLScheme = /*#__PURE__*/function (EndpointURLScheme) {
  EndpointURLScheme["HTTP"] = "http";
  EndpointURLScheme["HTTPS"] = "https";
  return EndpointURLScheme;
}(EndpointURLScheme || {});